import React from "react";
import { Row, Col, Button, Modal } from "antd";
import styled, { withTheme } from "styled-components";
import I18n from "../../../i18n";
import ColorUtil from "../../../util/ColorUtil";
import { Container } from "./style";
import Colors, { DataVisualizeKeys } from "../../../theme/Colors";
import { Metrics } from "../../../theme";

const TextDetail = styled.div`
    font-size: ${Metrics.fontSize.content};
    height:60px;
    overflow:hidden;
    text-overflow:ellipsis;
    color:rgba(0,0,0,0.4);
`;
export const InfoContainer = withTheme(({theme, info = "", descriptionTitle, description = "", valueColor = Colors.mainColor, style = {} })=>(
	<Container style={{ alignItems:"center",display:"flex", height:130, margin:0,...style }}>
		<Row type="flex" justify="space-between" align="middle" style={{width:"100%"}}>
			<Col span={12} style={{ fontSize: Metrics.fontSize.bold, textAlign: "left" }}>{info}</Col>
			<Col span={12} style={{fontSize: Metrics.fontSize.content}}>
				<TextDetail>{description}</TextDetail>
				<div style={{
					color:valueColor,
					textAlign:"center",
					cursor:"pointer",
					marginTop:4,
					marginBottom:4
				}} onClick={()=>{
					Modal.info({
						title:descriptionTitle,
						content:description
					});
				}}>{I18n.t("load_more")}</div>
			</Col>
		</Row>
	</Container>
));

const TotalInformation = ({ total = 0, valueFontSize = 36, valueColor = Colors.mainColor, description = "", style = {} }) => (
	<Container style={{ ...style, margin:0 }}>
		<Row type="flex" justify="space-between" align="middle" style={{ ...style }}>
			<Col span={12} style={{ fontSize: valueFontSize, color: valueColor, textAlign: "center" }}>{total}</Col>
			<Col span={12} style={{ textAlign: "center", fontSize: 18 }}>{description}</Col>
		</Row>
	</Container>
);
export const VisualTotalInfomation = withTheme((props)=>
	<TotalInformation {...props} valueColor = { 
		ColorUtil.getVisualizeColor(props.theme, props.visualColorKey, 0)
	}/>
);
export default TotalInformation;


// WEBPACK FOOTER //
// ./src/components/report/individual_user/TotalInformation.js